<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          ref="routingNumber"
          label="Routing Number"
          v-model="routingNumber"
          placeholder="110000000"
          :rules="[() => !!routingNumber || 'This field is required']"
          @input="handleInput"/>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          ref="accountNumber"
          label="Account Number"
          v-model="accountNumber"
          placeholder="000123456789"
          :rules="[() => !!accountNumber || 'This field is required']"
          @input="handleInput"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formValidation } from '../../mixins/validation.mixins';

export default {
  mixins: [formValidation],
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      routingNumber: this.value.routingNumber,
      accountNumber: this.value.accountNumber,
    };
  },
  methods: {
    handleInput() {
      this.$emit('input', {
        routingNumber: this.routingNumber,
        accountNumber: this.accountNumber,
      });
    },
  },
};
</script>
